import { rootApi } from "..";
import { dailyReportService } from "../../../Api/Services/DailyReportService";
import { employeeDetailService } from "../../../Api/Services/EmployeeDetailsService/EmplooyeeDetailsService";
import { hrService } from "../../../Api/Services/HRService";
import { userService } from "../../../Api/Services/UserService";
import { IEmployyeManagerUpdate } from "../../../Types/EmployeeManagerUpdate";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

const employeeEndpoints = [
  {
    name: "getEmployeesList",
    type: "query",
    serviceFn: ({
      manager,
      page,
      size,
      name,
      status,
      email,
    }: {
      manager: boolean | number;
      page?: number;
      size?: number;
      name?: string;
      status?: number;
      email?: string;
    }) =>
      dailyReportService.getUsersList({
        manager,
        page,
        size,
        name,
        status,
        email,
      }),
  },
  {
    name: "getEmployeeDetails",
    type: "query",
    serviceFn: (userId: string) =>
      employeeDetailService.getProfileDetailsService(userId),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeFamilyInfo",
    type: "mutation",
    serviceFn: (payload: { formData: FormData; userId: string }) =>
      employeeDetailService.createUpdateFamilyInformation(payload.formData),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeePersonalInfo",
    type: "mutation",
    serviceFn: (payload: { formData: FormData }) =>
      employeeDetailService.createUpdatePersonalInformation(payload.formData),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeOfficialInfo",
    type: "mutation",
    serviceFn: (payload: { formData: FormData }) =>
      employeeDetailService.createUpdateOfficialInformation(payload.formData),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeWorkInfo",
    type: "mutation",
    serviceFn: (payload: { formData: FormData }) =>
      employeeDetailService.createUpdateWorkDetails(payload.formData),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeEducationInfo",
    type: "mutation",
    serviceFn: (payload: { formData: FormData }) =>
      employeeDetailService.createUpdateEducationInformation(payload.formData),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeFinancialInfo",
    type: "mutation",
    serviceFn: (payload: { formData: FormData; userId: number }) =>
      employeeDetailService.createUpdateFinancialDetails(
        payload.formData,
        payload.userId
      ),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeStatus",
    type: "mutation",
    serviceFn: (payload: { user_id: number; status: string }) =>
      hrService.employeeStatusUpdate(payload),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeResetPassword",
    type: "mutation",
    serviceFn: (payload: { email: string }) =>
      userService.sendResetPasswordEmail(payload.email),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeExitInitiation",
    type: "mutation",
    serviceFn: (payload: FormData) => userService.initiateExit(payload),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeManager",
    type: "mutation",
    serviceFn: (payload: IEmployyeManagerUpdate) =>
      hrService.updateEmployeeManger(payload),
    tagType: "EmployeeInfo",
  },
  {
    name: "updateEmployeeProfilePic",
    type: "mutation",
    serviceFn: (params: FormData) =>
      employeeDetailService.updateProfilePic(params),
    tagType: "EmployeeInfo",
  },
  {
    name: "getEmployeeBanksList",
    type: "query",
    serviceFn: () => employeeDetailService.getEmployeeBanksList(),
  },
  {
    name: "getEmployeeJobTypes",
    type: "query",
    serviceFn: () => employeeDetailService.getEmployeeJobTypesList(),
  },
] as const;

export const employeeApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, employeeEndpoints),
});

export const {
  useGetEmployeesListQuery,
  useGetEmployeeDetailsQuery,
  useGetEmployeeJobTypesQuery,
  useGetEmployeeBanksListQuery,
  useUpdateEmployeeStatusMutation,
  useUpdateEmployeeManagerMutation,
  useUpdateEmployeeWorkInfoMutation,
  useUpdateEmployeeProfilePicMutation,
  useUpdateEmployeeFamilyInfoMutation,
  useUpdateEmployeePersonalInfoMutation,
  useUpdateEmployeeOfficialInfoMutation,
  useUpdateEmployeeFinancialInfoMutation,
  useUpdateEmployeeEducationInfoMutation,
  useUpdateEmployeeResetPasswordMutation,
  useUpdateEmployeeExitInitiationMutation,
} = employeeApi;
